import { View } from "react-native";
import React, { useState } from "react";
import { useRouter, useNavigation } from "expo-router";
import { useAuth } from "@components/auth/useAuth";

import ThemedScreen from "@/components/ThemedScreen";
import { CustomAlert } from "@/components/ThemedAlert";
import { ThemedProgressBar } from "@/components/ThemedProgressBar";

import { useFirebase } from "@components/firebase/useFirebase";
import { createPlace } from "@/services/firebase/place-functions";
import { PlaceEditor } from "@/components/places/PlaceEditor";
import { navigateBackOrToList } from "@/utils/navigation";

/**
 * Screen for creating a new Place.
 */
export default function NewPlaceScreen() {
  const services = useFirebase();
  const { user } = useAuth(true);
  const router = useRouter();
  const navigation = useNavigation();

  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async (formData: any) => {
    if (!services) return;

    setIsSaving(true);
    try {
      const res = await createPlace(services, {
        ...formData,
      });

      if (res.status) {
        navigateBackOrToList(router, "/(tabs)/my-places", navigation);
      } else {
        CustomAlert.alert("Error", res.error || "Failed to create place.");
      }
    } catch (error: any) {
      console.error("Error creating place:", error);
      CustomAlert.alert("Error", error.message || "Unexpected error while saving.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <ThemedScreen title="New Place" loading={isSaving}>
      <View style={{ flex: 1 }}>
        <ThemedProgressBar loading={isSaving} />
        <PlaceEditor
          currentUserId={user?.uid}
          onSave={handleSave}
          onCancel={() => navigateBackOrToList(router, "/(tabs)/my-places", navigation)}
          isSaving={isSaving}
          submitTitle="Create Place"
        />
      </View>
    </ThemedScreen>
  );
}
